import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const RewardsWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
  padding-top: ${primitive.$spacing2};

  ${Styles.mobile`
    margin-bottom: calc(env(safe-area-inset-bottom) + 100px);
  `}
`;
